import { PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import { ShopPolicy } from '@shopify/hydrogen-react/storefront-api-types';

import { Box } from '@mui/material';
import { useSeekaConverge } from '@seeka-labs/converge-react';
import SeoHead from '../../components/head';
import { HorizontalSlantContainer } from '../../components/horizontal-slant-container';
import { DosageCalculator } from '../use/dosage/calculator';

export default function CalculatorPageTemplate() {
  const seeka = useSeekaConverge();
  useEffect(() => {
    seeka.track.viewContentItem({
      contentName: 'Dosage-framed',
    })
  }, [])

  return (
    <>
      <HorizontalSlantContainer autoHeight svgStyle={{ borderRadius: '40px' }} id={'calc'}>
        <Box
          sx={{ pt: { xs: "40px", sm: "40px", md: "30px" }, pb: { xs: "30px" }, color: 'white', textAlign: 'center' }}
        >
          <DosageCalculator isSiteFramed={true} />
        </Box>
      </HorizontalSlantContainer>
    </>
  )
}

export const Head = (props: PageProps<unknown, ShopPolicy>) => {
  return <SeoHead title={props.pageContext.title} description={`Dosage`} pathname={props.location.pathname} />
}